var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaneDeparture = function SvgPlaneDeparture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2301 9.07995C21.0301 8.85995 21.8601 9.33995 22.0701 10.1399C22.2801 10.9399 21.8101 11.7599 21.0001 11.9899C11.5501 14.5199 4.43009 16.4199 4.43009 16.4199L1.84009 11.9299L3.29009 11.5399L5.26009 13.0799L10.2301 11.7499L6.09009 4.57995L8.02009 4.06995L14.9201 10.4999L20.2301 9.07995ZM21.5001 19.4999H2.50009V21.4999H21.5001V19.4999Z"
  }))));
};
export default SvgPlaneDeparture;